import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../../providers/appProvider";
import tbl from "../../../../assets/Style/Table.module.css";
import cl from "./List.module.css";
import Add from "../Add/Add";
import { useQuotation } from "../../../../hooks/useQuotation";
import QuotationEditModal from "../Edit/Edit";
import QuotationDeleteModal from "../Delete/Delete";
import QuotationCopyModal from "../Copy/Copy";
import { selectStyle } from "./selectStyle";
import Select from "react-select";
import Search from "../../../../assets/Icon/Search";

const QuotationList = () => {
    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
    ];

    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'წაგებული' },
        { value: 2, label: 'მიმდინარე' },
        { value: 3, label: 'მოგებული' },
    ];

    const tabs = [
        { value: 1, label: "აქტიური" },
        { value: 2, label: "არქივი" }
    ];

    const { appState, app } = useContext(AppContext);
    const { QuotationService } = useQuotation(50, true);
    const salers = appState.salers.map((user) => ({
        value: user.id,
        label: user.firstname + " " + user.lastname,
    }));
    const [receiverCountries, setReceiverCountries] = useState([]);
    const [senderCountries, setSenderCountries] = useState([]);
    const [currentTab, setCurrentTab] = useState([]);

    useEffect(() => {
        QuotationService.fetchList();
    }, []);

    useEffect(() => {
        const senderCountriesData = Array.from(
            new Set(appState.prices.map((item) => item.sender_country_id))
        ).map((countryId) => {
            const country = appState.countries.find(
                (country) => country.id === countryId
            );
            return country ? {
                value: country.id,
                label: country.name,
            } : null;
        }).filter(Boolean);

        const receiverCountriesData = Array.from(
            new Set(appState.prices.map((item) => item.reciever_country_id))
        ).map((countryId) => {
            const country = appState.countries.find(
                (country) => country.id === countryId
            );
            return country ? {
                value: country.id,
                label: country.name,
            } : null;
        }).filter(Boolean);

        setSenderCountries(senderCountriesData);
        setReceiverCountries(receiverCountriesData);
    }, [appState.countries, appState.prices]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        QuotationService.setFilter({
            ...QuotationService.filter,
            [name]: value,
            page: 1,
        });
    };

    const handleUnifiedSearchInputChange = (event) => {
        const { name, value } = event.target;

        QuotationService.setFilter({
        ...QuotationService.filter,
            [name]: value,
            page: 1,
        });
  };

    const onChangeTab = (val) => {
        setCurrentTab(val.value);
        switch (val.value) {
            case 1:
                QuotationService.setFilter((prevState) => ({
                    ...prevState,
                    is_archive: false,
                    page: 1,
                }));
                break;
            case 2:
                QuotationService.setFilter((prevState) => ({
                    ...prevState,
                    is_archive: true,
                    page: 1,
                }));
                break;
            default:
                QuotationService.setFilter((prevState) => ({
                    ...prevState,
                    is_archive: false,
                    page: 1,
                }));
        }
    };

    return (
        <div>
            <div className={cl.headMain}>
                <h1>ქვოთეიშენი</h1>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    {app.hasPermission("QUOTATION_UPLOAD") && (
                        <>
                            <Add QuotationService={QuotationService}/>
                        </>
                    )}
                </div>
            </div>
            <div className={cl.groupInput}>
              <div className={cl.groupInputIcon}>
                <input
                  name="client_query"
                  className={cl.input}
                  placeholder="ID, VIN, Lot ..."
                  value={QuotationService.filter.search_query}
                  onChange={handleUnifiedSearchInputChange}
                />
              </div>
            </div>
            <div className={cl.searchBox}>
                <div className={cl.col}>
                    <div className={cl.inBox}>
                        <Select
                            styles={selectStyle}
                            options={tabs}
                            value={tabs.find((option) => option.value === currentTab)}
                            onChange={onChangeTab}
                            placeholder="სტატუსი"
                        />
                    </div>
                </div>
            </div>
            <div 
                className={tbl.table + " " + cl.table}
                style={{ height: "calc(100vh - 158px)", background: "white" }}
            >
                <table>
                    <thead>
                        <tr>
                            <th className={cl.id}>
                                <input
                                    style={{ minWidth: '67px', textAlign: 'center', backgroundColor: 'transparent' }}
                                    name="quotation_id"
                                    placeholder="ID"
                                    value={QuotationService.filter.id}
                                    onChange={handleInputChange}
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={salers}
                                    value={salers.find(
                                        (option) => option.value === QuotationService.filter.saler_id
                                    )}
                                    onChange={(selectedOption) => {
                                        QuotationService.setFilter((prevState) => ({
                                            ...prevState,
                                            saler_id: selectedOption ? selectedOption.value : 0,
                                            page: 1,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="გაყიდვების მენეჯერი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={statusTypes}
                                    value={statusTypes.find(
                                        (option) => option.value === QuotationService.filter.status_id
                                    )}
                                    onChange={(selectedOption) => {
                                        QuotationService.setFilter((prevState) => ({
                                            ...prevState,
                                            status_id: selectedOption ? selectedOption.value : 0,
                                            page: 1,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="სტატუსი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={salers}
                                    value={salers.find(
                                        (option) => option.value === QuotationService.filter.user_id
                                    )}
                                    onChange={(selectedOption) => {
                                        QuotationService.setFilter((prevState) => ({
                                            ...prevState,
                                            user_id: selectedOption ? selectedOption.value : 0,
                                            page: 1,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="მომხმარებელი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={senderCountries}
                                    value={senderCountries.find(
                                        (option) => option.value === QuotationService.filter.sender_country_id
                                    )}
                                    onChange={(selectedOption) => {
                                        QuotationService.setFilter((prevState) => ({
                                            ...prevState,
                                            sender_country_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="ჩატვირთვის ქვეყანა"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={receiverCountries}
                                    value={receiverCountries.find(
                                        (option) => option.value === QuotationService.filter.reciever_country_id
                                    )}
                                    onChange={(selectedOption) => {
                                        QuotationService.setFilter((prevState) => ({
                                            ...prevState,
                                            reciever_country_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="დაცლის ქვეყანა"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={initialTypeOptions}
                                    value={initialTypeOptions.find(
                                        (option) => option.value === QuotationService.filter.type_id
                                    )}
                                    onChange={(selectedOption) => {
                                        QuotationService.setFilter((prevState) => ({
                                            ...prevState,
                                            type_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="გადაზიდვის ტიპი"
                                />
                            </th>

                            <th className={cl.id}>შექმნა</th>
                            <th className={cl.id}>განახლება</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {QuotationService.items != null ? QuotationService.items.map((q) => (
                            <tr key={q.quotation_id}>
                                <td style={{textAlign: 'center'}}>{q.quotation_id}</td>
                                <td>{q.seller.firstname + ' ' + q.seller.lastname}</td>
                                <td>
                                    {statusTypes && statusTypes.length > 0
                                        ? statusTypes.find(option => option.value === q.status_id)?.label || 'Unknown'
                                        : 'სტატუსი არ არის მინიჭებული'}
                                </td>
                                <td>{q.user ? q.user.firstname + ' ' + q.user.lastname : 'Unknown'}</td>
                                <td>
                                    {appState.countries && appState.countries.length > 0
                                        ? appState.countries.find(option => option.id === q.sender_country_id)?.name || 'Unknown'
                                        : 'ქვეყანა არ არის მინიჭებული'}
                                </td>
                                <td>
                                    {appState.countries && appState.countries.length > 0
                                        ? appState.countries.find(option => option.id === q.reciever_country_id)?.name || 'Unknown'
                                        : 'ქვეყანა არ არის მინიჭებული'}
                                </td>
                                <td>
                                    {initialTypeOptions && initialTypeOptions.length > 0
                                        ? initialTypeOptions.find(option => option.value === q.type_id)?.label || 'Unknown'
                                        : 'სტატუსი არ არის მინიჭებული'}
                                </td>
                                <td>{new Date(q.created_at).toLocaleString()}</td>
                                <td>{new Date(q.updated_at).toLocaleString()}</td>
                                <td className={cl.btntbl}>
                                    <div className={cl.btns}>
                                        <>
                                            <QuotationEditModal
                                                QuotationService={QuotationService}
                                                defaultQuotation={q}
                                            />
                                            <QuotationDeleteModal
                                                QuotationService={QuotationService}
                                                defaultQuotation={q}
                                            />
                                            <QuotationCopyModal
                                                QuotationService={QuotationService}
                                                defaultQuotation={q}
                                            />
                                        </>
                                    </div>
                                </td>
                            </tr>
                        )) : <div></div>}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default QuotationList;